import React, { FC, useState } from 'react';
import {
  Box,
  Stack,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography as Muitypo,
  useTheme,
} from '@mui/material';
import { Icon } from '@iconify/react';
import TextField from '../../components/TextField/TextField';
import { Select } from '../../components';
import { Vehicle } from '../../types';

interface selectOption {
  label?: string;
  value?: string;
}
type Props = {
  toBulkActionEvent: Vehicle[] | [];
  assignmentTypes: any;
  selectedAssignemntOption?: string | '';
  selectedBusinessOption?: string | '';
  bulkComment?: string | '';
  // handleBulkComment?: (event?: any) => void;
};

export const ActionModal = (
  <Stack py={1} spacing={2}>
    <Stack>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ borderBottom: 0, color: '#000006' }}>
              <Muitypo variant="body1">VIN</Muitypo>
            </TableCell>
            <TableCell sx={{ borderBottom: 0, color: '#000006' }}>
              <Muitypo variant="body1">Assignment Type</Muitypo>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {/* {toActionEvent.length > 0 && (
          <TableRow>
            <TableCell sx={{ borderBottom: 0, fontSize: 12 }}>
              <Muitypo variant="caption">{toActionEvent[0]?.vin}</Muitypo>
            </TableCell>
            <TableCell sx={{ borderBottom: 0 }}>
              <Muitypo variant="caption">{toActionEvent[0]?.assignmentType}</Muitypo>
            </TableCell>
          </TableRow>
          )} */}
        </TableBody>
      </Table>
    </Stack>
    <Stack direction="row" gap={1} alignItems="center">
      <Muitypo fontSize={12}>Assignment Types</Muitypo>
      {/* <Select
        options={AssignmentOptions}
        height={theme.typography.pxToRem(40)}
        selectDefault={true}
        setSelectedOption={(o: any) => selectedAssignemntOption = o }
      /> */}
    </Stack>
    <Stack direction="row" gap={1} alignItems="center">
      <Muitypo fontSize={12}>Business Area</Muitypo>
      {/* <Select
        options={businessOptions}
        height={theme.typography.pxToRem(40)}
        selectDefault={true}
        setSelectedOption={(o: any) => selectedBusinessOption = o }
      /> */}
    </Stack>
    <Stack>
      <Muitypo variant="body1">Comment</Muitypo>
      {/* <TextField placeholder="Enter comment" sx={{ fontSize: 12, height: 36 }} onChange={handleBulkComment} /> */}
    </Stack>
  </Stack>
);

export const BulkActionWarning = (
  <Stack py={1} spacing={2}>
    <Box
      p={1}
      mx={1}
      sx={{
        color: '#c3493b',
        display: 'flex',
        border: '1px solid #c3493b',
        borderRadius: 2,
        alignItems: 'center',
      }}
    >
      <Icon icon="charm:circle-warning" color="#c3493b" />
      <Muitypo variant="caption" ml={1}>
        Bulk action cannot be made.
      </Muitypo>
    </Box>
    <Stack direction="row" gap={1} alignItems="center">
      <Muitypo fontSize={15}>Please select at least 1 vehicle to perform a bulk action.</Muitypo>
    </Stack>
  </Stack>
);

export const BulkActionLimit = (
  <Stack py={1} spacing={2}>
    <Box
      p={1}
      mx={1}
      sx={{
        color: '#c3493b',
        display: 'flex',
        border: '1px solid #c3493b',
        borderRadius: 2,
        alignItems: 'center',
      }}
    >
      <Icon icon="charm:circle-warning" color="#c3493b" />
      <Muitypo variant="caption" ml={1}>
        Bulk action cannot be made.
      </Muitypo>
    </Box>
    <Stack direction="row" gap={1} alignItems="center">
      <Muitypo fontSize={15}>Please select less than 50 vehicle to perform a bulk action.</Muitypo>
    </Stack>
  </Stack>
);

export const BulkActionModal: FC<Props> = ({
  toBulkActionEvent,
  assignmentTypes,
  selectedAssignemntOption,
  selectedBusinessOption,
  bulkComment,
}) => {
  const theme = useTheme();
  // const [assignmentTypes, setAssignmentTypes] = useState<any>({});
  // let bulkComment = '';
  // let selectedBusinessOption = '';
  // let selectedAssignemntOption = '';
  const assignmentOptions = [{ label: 'Select Assignment Type', value: 'Select  Assignment Type' }];
  const assignmentOptionsNew =
    assignmentTypes &&
    assignmentTypes[0]?.assignmentType.forEach((ele: any) => assignmentOptions.push({ label: ele, value: ele }));
  const businessOptions = [{ label: 'Select Business Area', value: 'Select Business Area' }];
  const businessOptionsNew =
    assignmentTypes &&
    assignmentTypes[0]?.businessArea.forEach((ele: any) => businessOptions.push({ label: ele, value: ele }));

  const handleBulkComment = (e: any) => {
    bulkComment = e.target.value;
  };
  return (
    <Stack py={1} spacing={2}>
      {/* {toBulkActionEvent.length > 0 && ( */}
      <Box
        p={1}
        mx={1}
        sx={{
          color: '#c3493b',
          display: 'flex',
          border: '1px solid #c3493b',
          borderRadius: 2,
          alignItems: 'center',
        }}
      >
        <Icon icon="charm:circle-warning" color="#c3493b" />
        <Muitypo variant="caption" ml={1}>
          Please be careful with bulk editing. This action cannot be reversed.
        </Muitypo>
      </Box>
      {/* )} */}
      <Stack>
        <Muitypo variant="caption" ml={1} sx={{ fontSize: '16px' }}>
          Would you like the changes the assignment type for the {toBulkActionEvent.length} vehicles below? Please{' '}
          confirm to make changes.
        </Muitypo>
      </Stack>
      <Stack>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ borderBottom: 0, color: '#000006', padding: '1px' }}>
                <Muitypo variant="body1">VIN</Muitypo>
              </TableCell>
              <TableCell sx={{ borderBottom: 0, color: '#000006', padding: '1px' }}>
                <Muitypo variant="body1">Assignment Type</Muitypo>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {toBulkActionEvent.map((value: any) => {
              return (
                <TableRow key={value._id}>
                  <TableCell sx={{ borderBottom: 0, fontSize: '16px', height: 20, padding: '1px' }}>
                    <Muitypo variant="caption">{value.vin}</Muitypo>
                  </TableCell>
                  <TableCell sx={{ borderBottom: 0, fontSize: '16px', height: 20, padding: '1px' }}>
                    <Muitypo variant="caption">{value.assignmentType}</Muitypo>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Stack>
      <Stack direction="column" gap={1} alignItems="left">
        <Muitypo variant="body1">Assignment Types</Muitypo>
        <Select
          options={assignmentOptions}
          height={theme.typography.pxToRem(40)}
          setSelectedOption={(o: any) => {
            selectedAssignemntOption = o;
          }}
        />
      </Stack>
      <Stack direction="column" gap={1} alignItems="left">
        <Muitypo variant="body1">Business Area</Muitypo>
        <Select
          options={businessOptions}
          height={theme.typography.pxToRem(40)}
          setSelectedOption={(o: any) => {
            selectedBusinessOption = o;
          }}
        />
      </Stack>
      <Stack>
        <Muitypo variant="body1">Comment</Muitypo>
        {/* <TextField placeholder="Enter comment" sx={{ fontSize: 12, height: 36 }} onChange={handleBulkComment} /> */}
      </Stack>
    </Stack>
  );
};
